module.exports = __webpack_public_path__ + "a9981a62038cf3f06308a6e7ee984244.png";